import { render, staticRenderFns } from "./ItsBaseSubjectTemplate.vue?vue&type=template&id=e82b21c6&scoped=true&"
import script from "./ItsBaseSubjectTemplate.vue?vue&type=script&lang=js&"
export * from "./ItsBaseSubjectTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82b21c6",
  null
  
)

export default component.exports